import { NavLink } from 'react-router';
import logo from '#client/assets/images/ndc-logo.png';
import { cn } from '#client/lib/cn';
import { useCan } from '#client/hooks/useCan';
import { NAV_GROUPS } from './nav';

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const can = useCan();

  // Adaptive rendering: a group whose every item is filtered out renders
  // nothing at all, rather than leaving a heading over empty space. A
  // technician sees no Front-desk or Admin group.
  const visible = NAV_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => can(item.capability)),
  })).filter((group) => group.items.length > 0);

  return (
    <nav className="c-sidebar" aria-label="Main">
      <div className="c-sidebar__brand">
        <img className="c-sidebar__logo" src={logo} alt="NDC" />
      </div>

      {visible.map((group) => (
        <div className="c-sidebar__group" key={group.label ?? 'root'}>
          {group.label && <p className="c-sidebar__group-label">{group.label}</p>}

          <ul className="c-sidebar__list">
            {group.items.map(({ to, label, icon: Icon, end }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  end={end ?? false}
                  {...(onNavigate && { onClick: onNavigate })}
                  className={({ isActive }) =>
                    cn('c-sidebar__link', isActive && 'c-sidebar__link--active')
                  }
                >
                  <Icon aria-hidden />
                  <span>{label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
